export const DELIVERY_CARRIERS = [
  '佐川急便',
  'ヤマト運輸',
  '日本郵便',
  '西濃運輸',
  '福山通運',
]
